import React from "react";
import { useState, useEffect, useReducer, useRef } from "react";
/* import "./keyword-tracking-component.css"; */
import { Typeahead } from "react-bootstrap-typeahead";
import Select from "react-select";

import googleDomainsForSelector from "../FreeSerpChecker/google-domains2.json";
import { Spinner } from "react-bootstrap";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import {
  Col,
  Row,
  Card,
  Alert,
  Table,
  Layout,
  Modal,
  Divider,
  message,
  Space,
} from "antd";
import { tooltip as tooltipBootstrap } from "react-bootstrap";
import { Form, Button, OverlayTrigger } from "react-bootstrap";
/* import { ColumnsType } from "antd/es/table"; */
import Loading from "../SpinnerAndError/Loading";
import { Link, useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  UserOutlined,
  PieChartOutlined,
  CaretDownOutlined,
  MoreOutlined,
  CaretRightOutlined,
  PlusCircleOutlined,
  OrderedListOutlined,
  AreaChartOutlined,
  FallOutlined,
  RiseOutlined,
  ArrowUpOutlined,
  VerticalAlignMiddleOutlined,
  HeartOutlined,
  SketchOutlined,
  LikeOutlined,
  FireOutlined,
  ThunderboltOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

import { Fragment } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  Bars3BottomLeftIcon,
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  UsersIcon,
  XMarkIcon,
  CodeBracketIcon,
  ComputerDesktopIcon,
} from "@heroicons/react/24/outline";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedMednuItem, setSelectedMenuItem] = useState("Keyword Tracker");
  const [errorInFetching, setErrorInFetching] = useState(false);
  const [newDataSourceForTheTable, setNewDataSourceForTheTable] = useState([]);
  const [keyFordeDeleting, setKeyFordeDeleting] = useState("");
  const [keywordToDelete, setKeywordToDelete] = useState("");
  const [show, setShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showTop100Modal, setShowTop100Modal] = useState(false);
  const [showTrendModal, setShowTrendModal] = useState(false);
  const [showChangeGoogleRegionModal, setShowChangeGoogleRegionModal] =
    useState(false);
  const [email, setEmail] = useState();
  const [usersWebsite, setUsersWebsite] = useState();
  const [loading, setLoading] = useState(false);
  const [overallLoading, setOverallLoading] = useState(false);
  const [editedKeywordsHasBeenChanged, setEditedKeywordsHasBeenChanged] =
    useState(false);
  const [editedKeywords, setEditedKeywords] = useState([]);
  const [inputChangeOnTheGo, setInputChangeOnTheGo] = useState("");
  const [country, setCountry] = useState("United States");
  const [googleDomain, setGoogleDomain] = useState("google.com");
  const [languageCode, setlanguageCode] = useState("en");
  const [countryCode, setCountryCode] = useState("us");
  const [device, setDevice] = useState("");
  const [
    arrayOfKeywordsWithAllInformation,
    setArrayOfKeywordsWithAllInformation,
  ] = useState([]);
  const [keyForTheTop100List, setKeyForTheTop100List] = useState(0);
  const [keyForTheTrendsList, setKeyForTheTrendsList] = useState(0);
  const [keywordSelected, setKeywordSelected] = useState("");
  /* const [domainNameEntered, setDomainNameEntered] = useState(""); */
  //THE BELOW ONES ARE USED FOR CHANGING THE GOOGLE REGION
  const [selectedGoogleDomain, setSelectedGoogleDomain] = useState();
  const [googleRegionsChosen, setGoogleRegionsChosen] = useState(false);
  const [deviceChosen, setDeviceChosen] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [isCustomerPaying, setIsCustomerPaying] = useState(false);

  //FOR THE NUMBER OF KEYWORDS - PAYING / NON PAYING USERS
  const [numberOfKeywordsExceeded, setNumberOfKeywordsExceeded] =
    useState(false);
  const [
    numberOfKeywordsExceededForPayingUser,
    setNumberOfKeywordsExceededForPayingUser,
  ] = useState(false); //THIS ONE ONLY GOES "TRUE" IF A PAYING USER HAS ADDED MORE THAN 100 KEYWORDS.
  //UNTIL HERE*****************

  //FOR THE SUMMARY CARDS
  const [averagePositionForKeywords, setAveragePositionForKeywords] =
    useState(0);
  const [
    yesterdaysAveragePositionForKeywords,
    setYesterdaysAveragePositionForKeywords,
  ] = useState(0);

  const [
    numberOfKeywordsThatHasImprovedSinceYesterday,
    setNumberOfKeywordsThatHasImprovedSinceYesterday,
  ] = useState(0);
  const [numberOfKeywordsInTop3, setNumberOfKeywordsInTop3] = useState(0);
  const [numberOfKeywordsInTop10, setNumberOfKeywordsInTop10] = useState(0);
  const [numberOfKeywordsInTop30, setNumberOfKeywordsInTop30] = useState(0);
  const [numberOfKeywordsInTop100, setNumberOfKeywordsInTop100] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop3,
    setYesterdaysNumberOfKeywordsInTop3,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop10,
    setYesterdaysNumberOfKeywordsInTop10,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop30,
    setYesterdaysNumberOfKeywordsInTop30,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop100,
    setYesterdaysNumberOfKeywordsInTop100,
  ] = useState(0);

  //FOR THE DRAWER:
  const [visible, setVisible] = useState(false);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  const { Header, Content, Footer, Sider } = Layout;

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const list = [FallOutlined];

  const navigation = [
    { name: "Dashboard", icon: HomeIcon, href: "/dashboard", current: true },
    {
      name: "Competitors",
      icon: UsersIcon,
      href: "/saved-reports",
      current: false,
    },
    {
      name: "Keyword tracker",
      icon: ChartBarIcon,
      href: "/keyword-tracker",
      current: false,
    },
    {
      name: "Meta-tag generator",
      icon: ComputerDesktopIcon,
      href: "/meta-checker",
      current: false,
    },
    {
      name: "Schema Markup",
      icon: CodeBracketIcon,
      href: "/schema-generator",
      current: false,
    },
  ];

  const avatarOnClickFunction = (event) => {
    const eventName = event.target.innerText;

    if (eventName === "Sign out") {
      logoutFunction();
    }
  };

  const userNavigation = [
    /* { name: "Your Profile", href: "#" },
    { name: "Settings", href: "#" }, */
    { name: "Sign out", href: "#" },
  ];

  const secondaryNavigation = [
    { name: usersWebsite, href: "#" },
    /* { name: "GraphQL API", href: "#" },
  { name: "Customer migration guides", href: "#" },
  { name: "Profit sharing program", href: "#" }, */
  ];

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "IGNORE" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    setNewDataSourceForTheTable([]); // JUST CLEARING THE KEYWORD TABLE ARRAY
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    setOverallLoading(true); //TURNING ON LOADER HERE
    fetchDataOnMount();
  }, [reRender]);

  //THIS IS THE FETCH DATA FUNCTION, THAT IE BEING CALLED ON COMPONENT DID MOUNT: *************************
  const fetchDataOnMount = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_FETCH_EXISTING_KEYWORD_DATA,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setOverallLoading(false); // TURNING OFF LOADER HERE
        setFirstTimeUser(data.firstTimeUser);
        setIsCustomerPaying(data.isCustomerPaying); // JUST A BOOLEAN - TRUE / FALSE
        setEmail(data.email);
        setUsersWebsite(data.website);
        setDevice(data.trackedDevice);
        setCountry(data.trackedCountry);
        setGoogleDomain(data.trackedGoogleDomain);
        setlanguageCode(data.trackedLanguageCode);
        setCountryCode(data.trackedCountryCode);
        const arrayOfKeywordsFromBackend = data?.keywords;
        console.log("Array of keywords:", arrayOfKeywordsFromBackend);
        const numberOfKeywordsToday = arrayOfKeywordsFromBackend.length;
        console.log("Top - number of keywords", numberOfKeywordsToday);

        setArrayOfKeywordsWithAllInformation(arrayOfKeywordsFromBackend);
        /* console.log("array of keywords: ", arrayOfKeywordsFromBackend); */

        let keywordPositionSumArray = [];
        let yesterdaysKeywordPositionSumArray = [];
        let numberOfImprovedKeywordsArray = [];
        let numberOfKeywordsBetween1And3Array = [];
        let numberOfKeywordsInTop10Array = [];
        let numberOfKeywordsInTop30Array = [];
        let numberOfKeywordsInTop100Array = [];
        let yesterdaysNumberOfKeywordsBetween1And3Array = [];
        let yesterdaysNumberOfKeywordsInTop10Array = [];
        let yesterdaysNumberOfKeywordsInTop30Array = [];
        let yesterdaysNumberOfKeywordsInTop100Array = [];

        console.log("Length, ", arrayOfKeywordsFromBackend.length);

        console.log();

        //TEHRE IS SOME KIND OF BUG HERE:
        if (Object.keys(arrayOfKeywordsFromBackend).length > 0) {
          arrayOfKeywordsFromBackend.map((e, index) => {
            const lowestNumber = e.historicRankingsForThisKeyword.reduce(
              (a, b) => (a.rankingPosition < b.rankingPosition ? a : b)
            );

            console.log("lowest number ", lowestNumber);

            const firstTrackedPosition =
              e.historicRankingsForThisKeyword[0]?.rankingPosition; // THIS IS THE POSITION THAT WAS THE FIRST ONE WHEN KEYWORD WAS FIRST ADDED.
            const latest =
              e.historicRankingsForThisKeyword.slice(-1)[0]?.rankingPosition; // THIS IS GIVING BACK THE LAST ONE IN THE ARRAY
            const previousToLatest =
              e.historicRankingsForThisKeyword.slice(-2)[0]?.rankingPosition; // THIS IS GIVING BACK THE SECOND LATEST POSITION IN THE ARRAY
            const change = latest - previousToLatest;
            console.log("change", change);
            if (change < 0) {
              //IF THE KEYWORD HAS IMPROVED IN RANKING (MEANING THAT IT IS MINUS) , THEN I PUSH "1" TO THE ARRAY
              numberOfImprovedKeywordsArray.push(1);
            }
            //THIS IS FOR CALCULATING THE AVERAGE POSITION
            if (Number.isInteger(e.currentRankingPosition))
              keywordPositionSumArray.push(e.currentRankingPosition);
            //THIS IS FOR CALCULATING YESTERDAYS AVERAGE POSITION
            if (Number.isInteger(previousToLatest))
              yesterdaysKeywordPositionSumArray.push(previousToLatest);

            //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS IN TOP3/10/30/100
            if (e.currentRankingPosition <= 3) {
              numberOfKeywordsBetween1And3Array.push(1);
            }
            if (e.currentRankingPosition <= 10) {
              numberOfKeywordsInTop10Array.push(1);
            }
            if (e.currentRankingPosition <= 30) {
              numberOfKeywordsInTop30Array.push(1);
            }
            if (e.currentRankingPosition <= 100) {
              numberOfKeywordsInTop100Array.push(1);
            }
            //BELOW I AM CALCULATING YESTERDAYS NUMBER OF KEYWORDS IN TOP3/10/30/100
            if (previousToLatest <= 3) {
              yesterdaysNumberOfKeywordsBetween1And3Array.push(1);
            }
            if (previousToLatest <= 10) {
              yesterdaysNumberOfKeywordsInTop10Array.push(1);
            }
            if (previousToLatest <= 30) {
              yesterdaysNumberOfKeywordsInTop30Array.push(1);
            }
            if (previousToLatest <= 100) {
              yesterdaysNumberOfKeywordsInTop100Array.push(1);
            }

            console.log("Lowest number ", lowestNumber);

            const latestChange = setNewDataSourceForTheTable((data) => [
              ...data,
              {
                key: index + 1,
                keyword: e.keyword,
                change: change ? change : 0, // IF "NOT A NUMBER" THEN I CHANGE IT TO "0"
                latest: latest,
                best: lowestNumber?.rankingPosition,
                first: firstTrackedPosition,
                /* position: e.currentRankingPosition, */
                last_updated: e.lastUpdate,
                url_ranking: e.URLRanking,
                action: "delete",
              },
            ]);
          });
          //BELOW HERE I AM DOING ALL THE CALCULATIONS FOR THE SUMMARY CARDS BASED ON THE ARRAYS I AM PUSHING INTO ABOVE

          //CALCULATING TODAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
          const sumOfAllCurrentPositions = keywordPositionSumArray.reduce(
            //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
            (partialSum, a) => partialSum + a,
            0
          );
          console.log(
            "Sum of all current positions:",
            sumOfAllCurrentPositions
          );

          /*   const numberOfKeywords = newDataSourceForTheTable.length; */ //NUMBER OF KEYWORDS BEING TRACKED

          console.log("sum", sumOfAllCurrentPositions);
          const averagePosition =
            sumOfAllCurrentPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS
          console.log("Average Position", averagePosition);
          const first4StrOfAveragePosition = String(averagePosition).slice(
            // I JUST NEED THE FIRST 4 STRINGS
            0,
            4
          ); // I ONLY WANT THE FIRST 4 NUMBERS (IN CASE IT IS A VERY LONG NUMBER)
          console.log(first4StrOfAveragePosition);
          setAveragePositionForKeywords(first4StrOfAveragePosition);

          //CALCULATING YESTERDAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
          const sumOfAllYesterdaysPositions =
            yesterdaysKeywordPositionSumArray.reduce(
              //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
              (partialSum, a) => partialSum + a,
              0
            );
          console.log(
            "Sum of all yesterdays positions:",
            sumOfAllYesterdaysPositions
          );

          /* const numberOfKeywords2 = newDataSourceForTheTable.length; */ //THIS IS ACTUALLY NOT 100% CORRECT AS THIS IS TODAYS NUMBER OF TRACKED KWYWORDS.
          /* console.log("Number of Keywords yesterday: ", numberOfKeywords2); */
          const yesterdaysAveragePosition =
            sumOfAllYesterdaysPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS
          console.log("Average Position yesterday", yesterdaysAveragePosition);
          const first4StrOfYesterdaysAveragePosition = String(
            // I JUST NEED THE FIRST 4 STRINGS
            yesterdaysAveragePosition
          ).slice(0, 4);
          setYesterdaysAveragePositionForKeywords(
            first4StrOfYesterdaysAveragePosition
          );

          //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS THAT HAVE IMPROVED SINCE THE DAY BEFORE.
          const numberOfKeywordsThatImproved =
            numberOfImprovedKeywordsArray.length;
          console.log(
            "Number of keywords that improved: ",
            numberOfKeywordsThatImproved
          );
          setNumberOfKeywordsThatHasImprovedSinceYesterday(
            numberOfKeywordsThatImproved
          );
          //BELOW I AM CALCULATING THE LENGTH OF THE "KEYWORDS IN TOP 3/10/30/100" ARRAYS
          //AND SETTING THEM IN STATE.
          const numberOfKeywordsInTop3 =
            numberOfKeywordsBetween1And3Array.length;
          const numberOfKeywordsInTop10 = numberOfKeywordsInTop10Array.length;
          const numberOfKeywordsInTop30 = numberOfKeywordsInTop30Array.length;
          const numberOfKeywordsInTop100 = numberOfKeywordsInTop100Array.length;

          setNumberOfKeywordsInTop3(numberOfKeywordsInTop3);
          setNumberOfKeywordsInTop10(numberOfKeywordsInTop10);
          setNumberOfKeywordsInTop30(numberOfKeywordsInTop30);
          setNumberOfKeywordsInTop100(numberOfKeywordsInTop100);

          //BELOW I AM CALCULATING THE LENGTH OF "YESTERDAYS KEYWORDS IN TOP 3/10/30/100" ARRAYS
          //AND SETTING THEM IN STATE.

          const yesterdaysNumberOfKeywordsInTop3 =
            yesterdaysNumberOfKeywordsBetween1And3Array.length;
          const yesterdaysNumberOfKeywordsInTop10 =
            yesterdaysNumberOfKeywordsInTop10Array.length;
          const yesterdaysNumberOfKeywordsInTop30 =
            yesterdaysNumberOfKeywordsInTop30Array.length;
          const yesterdaysNumberOfKeywordsInTop100 =
            yesterdaysNumberOfKeywordsInTop100Array.length;

          setYesterdaysNumberOfKeywordsInTop3(yesterdaysNumberOfKeywordsInTop3);
          setYesterdaysNumberOfKeywordsInTop10(
            yesterdaysNumberOfKeywordsInTop10
          );
          setYesterdaysNumberOfKeywordsInTop30(
            yesterdaysNumberOfKeywordsInTop30
          );
          setYesterdaysNumberOfKeywordsInTop100(
            yesterdaysNumberOfKeywordsInTop100
          );
        }
      } else if (response.status === 401) {
        console.log("Token not valid");
        window.location.replace("/login"); // I AM ADDING THIS ONE , SO THAT THE USER WILL BE REDIRECTED TO THE LOGIN PAGE IN CASE THE TOKEN IS EXPIRED.
      }
    } catch (error) {
      console.log(error);
    }
  };

  //ADD KEYWORDS MODAL -  OPEN AND CLOSE:
  const closeShowAddKeywordsModal = () => setShow(false);
  const showAddKeywordsModal = () => setShow(true);

  //CHANGE GOOGLE REGION MODAL -  OPEN AND CLOSE:
  const closeTheChangeGoogleRegionsModalFunction = () =>
    setShowChangeGoogleRegionModal(false);
  const showTheChangeGoogleRegionsModalFunction = () =>
    setShowChangeGoogleRegionModal(true);

  /*   **** THIS IS THE ONE THAT IS TRIGGERED WHEN ADDING MORE KEYWORDS AS A PAYING USER ***** */
  const submitMoreKeywordsFunction = (event) => {
    event.preventDefault();
    setLoading(true);
    saveAndAddedKeywordsForUserAndSaveInDatabase();
    closeShowAddKeywordsModal();
  };

  const pushEditedKeywordsToArrayFunction = (propertyName, targetValue) => {
    /* console.log("Target value", targetValue); */

    setEditedKeywordsHasBeenChanged(true);
    setEditedKeywords({
      ...editedKeywords,
      [propertyName]: targetValue,
    });
  };

  //THIS IS THE FETCH FOR ADDING MORE KEYWORDS ***********************************
  const saveAndAddedKeywordsForUserAndSaveInDatabase = async () => {
    const bodyDataForExtraKeywordsAdded = {
      keywords: editedKeywords,
      trackedUserDomain: usersWebsite,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    //I START BY CALCULATING THE NUMBER OF KEYWORDS THAT THE USER HAS
    // IF IT IS TOO MANY THEN I WILL JUST SHOW A MESSAGE OF SOME KIND.
    const numberOfExistingAndNewKeywords =
      editedKeywords.keyword.length + arrayOfKeywordsWithAllInformation.length;
    /*     console.log(
      "Edited keywords + existing keywords",
      editedKeywords.keyword.length + arrayOfKeywordsWithAllInformation.length
    ); */

    if (numberOfExistingAndNewKeywords > 3 && isCustomerPaying === false) {
      setNumberOfKeywordsExceeded(true);
      setLoading(false);
      closeShowAddKeywordsModal();
    } else if (
      isCustomerPaying === true &&
      numberOfExistingAndNewKeywords > 100
    ) {
      setLoading(false);
      closeShowAddKeywordsModal();
      setNumberOfKeywordsExceededForPayingUser(true);
    } else {
      message.loading("keywords(s) are being added....", 5); // THIS IS THE LOADER ALERT IN THE TOP - WILL ONLY BE SHOWN IF THE USER IS "WITHIN THE LIMIT"
      try {
        const response = await fetch(
          process.env.REACT_APP_ADD_MORE_KEYWORDS_FOR_USER,
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token2}`,
            },
            body: JSON.stringify(bodyDataForExtraKeywordsAdded),
          }
        );
        if (response.status === 200) {
          const data = await response.json();
          setLoading(false);
          message.info("Keyword(s) added", 2.5);
          /* console.log("Data from backend,", data); */
          closeShowAddKeywordsModal();
          setEditedKeywords([]);
          typeaheadRef.current.clear(); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
          setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
          setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
        }
      } catch (error) {
        console.log(error);
        setErrorInFetching(true);
        typeaheadRef.current.clear(); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
        setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
      }
    }
  };

  //THESE BELOW ARE FOR THE GENERAL LAYOUT USING THE ANTD DESIGN:
  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
    setSelectedMenuItem({ key });
  };

  const typeaheadRef = useRef(null); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE

  //THIS IS FOR THE CLOSING OF THE MODAL
  const handleOk = () => {
    setShow(false);
    setNumberOfKeywordsExceeded(false);
    setNumberOfKeywordsExceededForPayingUser(false);
    setShowDeleteModal(false);
    setShowTop100Modal(false);
    setShowTrendModal(false);
    closeTheChangeGoogleRegionsModalFunction(false);
    typeaheadRef.current.clear(); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
    setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
  };
  const handleCancel = () => {
    setShow(false);
    setShowTrendModal(false);
    setShowDeleteModal(false);
    setNumberOfKeywordsExceeded(false);
    setNumberOfKeywordsExceededForPayingUser(false);
    setShowTop100Modal(false);
    closeTheChangeGoogleRegionsModalFunction(false);
    typeaheadRef.current.clear(); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
    setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
  };

  // SIDER AND DRAWER TOGGLE
  const [isToggled, setToggled] = useState(false);
  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const menu = (
    <Menu
      onClick={logoutFunction}
      items={[
        /*         {
          label: "My account",
          key: "1",
        }, */
        /* {
          label: "Billing",
          key: "2",
        }, */
        {
          label: (
            <span style={{ color: "red" }} onClick={logoutFunction}>
              Logout
            </span>
          ),
          key: "3",
        },
      ]}
    />
  );
  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    };
  }

  //DRAFT TABLE DATA  (THIS ONE IS NOT BEING USED ANYMORE - CAN BE DELETED):

  /* const dataSource = [
    {
      key: "1",
      keyword: "Mike",
      position: 32,
      last_updated: "22-9-22",
      url_ranking: "google.com",
      action: "delete",
    },
    {
      key: "2",
      keyword: "John",
      position: 42,
      last_updated: "22-9-22",
      url_ranking: "google.com",
      action: "delete",
    },
  ]; */

  //THIS IS THE FUNCTION THAT OPENS UP THE "ARE YOU SURE" MODAL :
  const openUpTheDeleteKeywordModal = (event) => {
    event.preventDefault();
    setShowDeleteModal(true);
    const key = event.target.closest("tr").attributes[0].nodeValue;
    const keywordToDelete = event.target
      .closest("tr")
      .childNodes.item(0).innerText;
    setKeywordToDelete(keywordToDelete);
    setKeyFordeDeleting(key);
  };

  //THIS IS THE FUNCTION THAT IS CALLED IF YOU CLICK THE "YES" BUTTON ON THE MODAL FOR DELETING A KEYWORD.
  const deleteARowInTableFunction = async (event) => {
    setShowDeleteModal(false);
    const key = keyFordeDeleting;
    /* console.log(key); */
    const bodyData = { key: key, keywordToDelete: keywordToDelete };
    /* console.log("BodyData", bodyData); */

    try {
      const response = await fetch(
        process.env.REACT_APP_DELETE_SINGLE_KEYWORD_FROM_NEW_VERSION_OF_APP,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        /* console.log(data); */
        setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      }
    } catch (error) {
      console.log(error);
      setErrorInFetching(true);
    }
  };

  // THESE ARE THE COLUMNS USED FOR THE OVERALL!! TABLE *****************************
  const columns = [
    {
      /* title: "Keyword", */
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Keyword</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Your keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "keyword",
      key: "keyword",
      width: 100,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Change</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Difference between yesterdays position and today's.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "change",
      key: "change",
      width: 100,
      render: (_, record) =>
        record.change < 0 ? (
          <span>
            {_}
            <RiseOutlined style={{ color: "green" }} />
          </span>
        ) : record.change === 0 ? (
          _
        ) : (
          <span>
            {_}
            <FallOutlined style={{ color: "red" }} />
          </span>
          /* (record, (<FallOutlined />)) */
          /* (record, (<RiseOutlined />)) */
        ),
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Latest</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The latest ranking position.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "latest",
      key: "latest",
      width: 100,
      sorter: (a, b) => a.latest - b.latest,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Best</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The highest position since starting to track keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "best",
      key: "best",
      width: 100,
      sorter: (a, b) => a.best - b.best,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>First</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The position when the keyword was added.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "first",
      key: "first",
      width: 100,
      sorter: (a, b) => a.first - b.first,
      render: (_, record) =>
        record.first > record.latest ? (
          <span>
            {_}
            <RiseOutlined style={{ color: "green" }} />
          </span>
        ) : record.first === record.latest ? (
          _
        ) : (
          <span>
            {_}
            <FallOutlined style={{ color: "red" }} />
          </span>
        ),
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Top domains</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The top domains for this keyword in ascending order.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      /* dataIndex: "action", */
      key: "topdomains",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <span
            onClick={openUpTheTop100Modal}
            className="show-top-domains-for-the-keyword"
          >
            <OrderedListOutlined />
          </span>
        </Space>
      ),
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Trend</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The historic ranking positions shown in a graph.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      /* dataIndex: "action", */
      key: "trend",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <span
            onClick={openUpTheTrendModal}
            className="show-top-domains-for-the-keyword"
          >
            <AreaChartOutlined />
          </span>
        </Space>
      ),
    },
    {
      title: "Last updated",
      dataIndex: "last_updated",
      key: "last_updated",
      width: 100,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>URL ranking</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The URL that is ranking for the keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "url_ranking",
      key: "url_ranking",
      width: 100,
    },
    {
      title: "Action",
      /* dataIndex: "action", */
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <span
            onClick={openUpTheDeleteKeywordModal}
            className="remove-item-box-for-deleting-a-keyword"
          >
            <DeleteOutlined />
          </span>
        </Space>
      ),
    },
  ];

  //BELOW ARE ALL THE FUNCTIONS AND STYLES FOR THE "CHANGE GOOGLE REGION" MODAL:

  const customStylesWhenNotDisabled = {
    control: (base, state) => ({
      ...base,

      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  const options = googleDomainsForSelector.sort((a, b) => {
    if (a.value.country_name < b.value.country_name) {
      return -1;
    }
    if (a.value.country_name > b.value.country_name) {
      return 1;
    }
    return 0;
  });

  const onChangeForGoogleRegion = (event) => {
    /* console.log(event); */
    setGoogleRegionsChosen(true);
    setCountry(event.value.country_name);
    setGoogleDomain(event.value.domain);
    setCountryCode(event.value.country_code);
    setlanguageCode(event.value.language_code);
  };

  //FOR THE DEVICE INPUT FIELD
  const deviceOptions = [
    { value: "Desktop", label: "Desktop" },
    { value: "Mobile", label: "Mobile" },
    { value: "Tablet", label: "Tablet" },
  ];

  const onChangeOfDeviceHandler = (change) => {
    setDevice(change.value);
    setDeviceChosen(true);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  // ********** UNTIL HERE - ABOVE ARE ALL THE FUNCTIONS AND STYLES FOR THE "CHANGE GOOGLE REGION" MODAL **********

  const handleSubmitForChangingGoogleRegionAndDevice = async () => {
    setLoading(true);

    const bodyDataForChangingGoogleRegionAndDevice = {
      trackedUserDomain: usersWebsite,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_SET_GOOGLE_REGION_AND_DEVICE_IN_USER_PROFILE, //THIS IS THE SAME ENDPOINT THAT I ALSO USE FOR MODAL 2 IN THE ONBOARDING JOURNEY.
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyDataForChangingGoogleRegionAndDevice),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setLoading(false);
        closeTheChangeGoogleRegionsModalFunction(); // TO CLOSE THE MODAL
        setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 404) {
        setLoading(false);
        setErrorInFetching(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard");
  };

  //BELOW IS THE FUNCTION WHEN CLICKING ON THE SHOW TREND BUTTON
  const openUpTheTrendModal = (event, index) => {
    event.preventDefault();
    setShowTrendModal(true);
    const key = event.target.closest("tr").attributes[0].nodeValue; //THIS IS KIND OF THE SAME AS GETTING THE INDEX NUMBER.
    /* console.log(key); */
    setKeyForTheTrendsList(key - 1);
    const keyword = event.target.closest("tr").childNodes.item(0).innerText;
    /* console.log(keyword); */
    setKeywordSelected(keyword);

    /* setKeywordToDelete(keywordToDelete);
  setKeyFordeDeleting(key); */
  };

  //BELOW IS THE TABLE FOR THE TOP 100 WHEN CLICKING ON THE SHOW TOP 100 MODAL

  const openUpTheTop100Modal = (event, index) => {
    event.preventDefault();
    setShowTop100Modal(true);
    const key = event.target.closest("tr").attributes[0].nodeValue; //THIS IS KIND OF THE SAME AS GETTING THE INDEX NUMBER.
    console.log(key);
    setKeyForTheTop100List(key - 1);

    const keyword = event.target.closest("tr").childNodes.item(0).innerText;
    /* console.log(keyword); */
    setKeywordSelected(keyword);

    /* setKeywordToDelete(keywordToDelete);
    setKeyFordeDeleting(key); */
  };

  const columnsForTheTop100Table = [
    {
      title: "#",
      dataIndex: "position",
      key: "position",
      width: 20,
    },
    {
      title: "URL",
      dataIndex: "link",
      key: "link",
      width: 100,
      render: (text, record) => (
        <a target="_blank" href={text}>
          {text}
        </a>
      ),
    },
    /* {
      title: "URL",
      dataIndex: "url",
      key: "url",
      width: 100,
    }, */
  ];

  let navigate = useNavigate();

  const navigateToPricesPageFunction = () => {
    navigate("https://serpmaze.com/#pricing");
  };

  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
      <div>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 md:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex flex-shrink-0 items-center px-4">
                    <img
                      className="h-12 w-auto"
                      src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                      alt="Your Company"
                    />
                  </div>
                  <div className="mt-5 h-0 flex-1 overflow-y-auto">
                    <nav className="space-y-1 px-2">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className={classNames(
                            item.current
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                            "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </a>
                      ))}
                      <div className="space-y-1 mt-5">
                        <h3
                          className="px-3 text-sm font-medium text-gray-500"
                          id="projects-headline"
                        >
                          Tracked sites
                        </h3>
                        <div
                          className="space-y-1"
                          role="group"
                          aria-labelledby="projects-headline"
                        >
                          {secondaryNavigation.map((item) => (
                            <a
                              key={item.name}
                              href={item.href}
                              className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                            >
                              <span className="truncate">{item.name}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="w-14 flex-shrink-0" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
            <div className="flex flex-shrink-0 items-center px-4">
              <img
                className="h-12 w-auto"
                src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                alt="SerpMaze"
              />
            </div>
            <div className="mt-5 flex flex-grow flex-col">
              <nav className="flex-1 space-y-1 px-2 pb-4">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className={classNames(
                      item.current
                        ? "bg-gray-100 text-gray-900"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                      "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                    )}
                  >
                    <item.icon
                      className={classNames(
                        item.current
                          ? "text-gray-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "mr-3 flex-shrink-0 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </a>
                ))}
                <div className="space-y-1 mt-5">
                  <h3
                    className="px-3 text-sm font-medium text-gray-500"
                    id="projects-headline"
                  >
                    Tracked sites
                  </h3>
                  <div
                    className="space-y-1"
                    role="group"
                    aria-labelledby="projects-headline"
                  >
                    {secondaryNavigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                      >
                        <span className="truncate">{item.name}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div className="flex flex-1 flex-col md:pl-64">
          <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
            <button
              type="button"
              className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex flex-1 justify-between px-4">
              <div className="flex flex-1">
                <form className="flex w-full md:ml-0" action="#" method="GET">
                  <label htmlFor="search-field" className="sr-only">
                    Search
                  </label>
                  <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                    {/* <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                      <MagnifyingGlassIcon
                        className="h-5 w-5"
                        aria-hidden="true"
                      />
                    </div> */}
                    <input
                      id="search-field"
                      className="block h-full w-full border-transparent py-2  pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 sm:text-sm"
                      placeholder={email}
                      type="search"
                      name="search"
                    />
                  </div>
                </form>{" "}
              </div>
              <div className="ml-4 flex items-center md:ml-6">
                <button
                  type="button"
                  className="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button>

                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      <span className="sr-only">Open user menu</span>
                      <img
                        className="h-8 w-8 rounded-full"
                        src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673362013/SerpMaze/SerpMaze_avatar_spkks6.png"
                        alt="Avatar picture"
                      />
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {userNavigation.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <a
                              onClick={avatarOnClickFunction}
                              href={item.href}
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block px-4 py-2 text-sm text-gray-700"
                              )}
                            >
                              {item.name}
                            </a>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>

          <main className="flex-1">
            <div className="py-6">
              {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Dashboard
                </h1>
              </div> */}
              <div className="">
                {" "}
                {/* mx-auto max-w-7xl px-4 sm:px-6 md:px-8 */}
                {/* Replace with your content */}
                {/*                 <div className="py-4">
                  <div className="h-96 rounded-lg border-4 border-dashed border-gray-200" />
                </div>
 */}
                {/* /End replace */}
                <Content>
                  <section className="general-layout ant-layout">
                    <main className="general-layout-content ant-layout-content">
                      <div className="ant-card analysis-form-card ant-card-bordered">
                        {/* <div className="ant-card-body"></div> */}
                      </div>

                      <div className="outer-wrapper-for-body-content">
                        {newDataSourceForTheTable.length > 0 &&
                          firstTimeUser === false && (
                            <>
                              <div>
                                <Divider id="summary-divider">Summary</Divider>
                              </div>
                              <Row
                                className="summary-row"
                                style={{ marginBottom: "24px" }}
                              >
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={8}
                                  xl={4}
                                  className="summary-cols"
                                  style={{
                                    minHeight: "10vh",
                                    maxheight: "10vh ",
                                  }}
                                >
                                  <div className="summary-div-for-keyword-tracker">
                                    <div>
                                      <small className="summary-div-small-text-top-card summary-text">
                                        <VerticalAlignMiddleOutlined />
                                        &nbsp; Average Position
                                      </small>
                                    </div>
                                    <div>
                                      <h2
                                        className="h2-within-summary-card-div summary-text"
                                        style={{
                                          color:
                                            averagePositionForKeywords <
                                            yesterdaysAveragePositionForKeywords
                                              ? "green"
                                              : averagePositionForKeywords ===
                                                yesterdaysAveragePositionForKeywords
                                              ? ""
                                              : "red",
                                        }}
                                      >
                                        {averagePositionForKeywords == NaN ||
                                        averagePositionForKeywords == Infinity
                                          ? "-"
                                          : averagePositionForKeywords}
                                      </h2>
                                    </div>
                                    <div>
                                      <small className="summary-div-small-text-bottom-card summary-text">
                                        vs.
                                        {
                                          yesterdaysAveragePositionForKeywords
                                        }{" "}
                                        yesterday
                                      </small>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={8}
                                  xl={4}
                                  className="summary-cols"
                                  style={{
                                    minHeight: "10vh",
                                    maxheight: "10vh ",
                                  }}
                                >
                                  <div className="summary-div-for-keyword-tracker">
                                    <div>
                                      <small className="summary-div-small-text-top-card summary-text">
                                        <ArrowUpOutlined />
                                        &nbsp; Improved
                                      </small>
                                    </div>
                                    <div>
                                      <h2
                                        className="h2-within-summary-card-div summary-text"
                                        style={{
                                          color:
                                            numberOfKeywordsThatHasImprovedSinceYesterday >
                                            0
                                              ? "green"
                                              : numberOfKeywordsThatHasImprovedSinceYesterday ===
                                                0
                                              ? ""
                                              : "red",
                                        }}
                                      >
                                        {
                                          numberOfKeywordsThatHasImprovedSinceYesterday
                                        }
                                        /{newDataSourceForTheTable.length}
                                      </h2>
                                    </div>
                                    <div>
                                      <small className="summary-div-small-text-bottom-card summary-text">
                                        -
                                      </small>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={8}
                                  xl={4}
                                  className="summary-cols"
                                  style={{
                                    minHeight: "10vh",
                                    maxheight: "10vh ",
                                  }}
                                >
                                  <div className="summary-div-for-keyword-tracker">
                                    <div>
                                      <small className="summary-div-small-text-top-card summary-text">
                                        <SketchOutlined />
                                        &nbsp; Top 3
                                      </small>
                                    </div>
                                    <div>
                                      <h2
                                        className="h2-within-summary-card-div summary-text"
                                        style={{
                                          color:
                                            numberOfKeywordsInTop3 >
                                            yesterdaysNumberOfKeywordsInTop3
                                              ? "green"
                                              : numberOfKeywordsInTop3 ===
                                                yesterdaysNumberOfKeywordsInTop3
                                              ? ""
                                              : "red",
                                        }}
                                      >
                                        {numberOfKeywordsInTop3}/
                                        {newDataSourceForTheTable.length}
                                      </h2>
                                    </div>
                                    <div>
                                      <small className="summary-div-small-text-bottom-card summary-text">
                                        vs. {yesterdaysNumberOfKeywordsInTop3}{" "}
                                        yesterday
                                      </small>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={8}
                                  xl={4}
                                  className="summary-cols"
                                  style={{
                                    minHeight: "10vh",
                                    maxheight: "10vh ",
                                  }}
                                >
                                  <div className="summary-div-for-keyword-tracker">
                                    <div>
                                      <small className="summary-div-small-text-top-card summary-text">
                                        <HeartOutlined />
                                        &nbsp; Top 10
                                      </small>
                                    </div>
                                    <div>
                                      <h2
                                        className="h2-within-summary-card-div summary-text"
                                        style={{
                                          color:
                                            numberOfKeywordsInTop10 >
                                            yesterdaysNumberOfKeywordsInTop10
                                              ? "green"
                                              : numberOfKeywordsInTop10 ===
                                                yesterdaysNumberOfKeywordsInTop10
                                              ? ""
                                              : "red",
                                        }}
                                      >
                                        {numberOfKeywordsInTop10}/
                                        {newDataSourceForTheTable.length}
                                      </h2>
                                    </div>
                                    <div>
                                      <small className="summary-div-small-text-bottom-card summary-text">
                                        vs. {yesterdaysNumberOfKeywordsInTop10}{" "}
                                        yesterday
                                      </small>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={8}
                                  xl={4}
                                  className="summary-cols"
                                  style={{
                                    minHeight: "10vh",
                                    maxheight: "10vh ",
                                  }}
                                >
                                  <div className="summary-div-for-keyword-tracker">
                                    <div>
                                      <small className="summary-div-small-text-top-card summary-text">
                                        <ThunderboltOutlined />
                                        &nbsp; Top 30
                                      </small>
                                    </div>
                                    <div>
                                      <h2
                                        className="h2-within-summary-card-div summary-text"
                                        style={{
                                          color:
                                            numberOfKeywordsInTop30 >
                                            yesterdaysNumberOfKeywordsInTop30
                                              ? "green"
                                              : numberOfKeywordsInTop30 ===
                                                yesterdaysNumberOfKeywordsInTop30
                                              ? ""
                                              : "red",
                                        }}
                                      >
                                        {numberOfKeywordsInTop30}/
                                        {newDataSourceForTheTable.length}
                                      </h2>
                                    </div>
                                    <div>
                                      <small className="summary-div-small-text-bottom-card summary-text">
                                        vs. {yesterdaysNumberOfKeywordsInTop30}{" "}
                                        yesterday
                                      </small>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={8}
                                  xl={4}
                                  className="summary-cols"
                                  style={{
                                    minHeight: "10vh",
                                    maxheight: "10vh ",
                                  }}
                                >
                                  <div className="summary-div-for-keyword-tracker">
                                    <div>
                                      <small className="summary-div-small-text-top-card summary-text">
                                        <LikeOutlined />
                                        &nbsp; Top 100
                                      </small>
                                    </div>
                                    <div>
                                      <h2
                                        className="h2-within-summary-card-div summary-text"
                                        style={{
                                          color:
                                            numberOfKeywordsInTop100 >
                                            yesterdaysNumberOfKeywordsInTop100
                                              ? "green"
                                              : numberOfKeywordsInTop100 ===
                                                yesterdaysNumberOfKeywordsInTop100
                                              ? ""
                                              : "red",
                                        }}
                                      >
                                        {numberOfKeywordsInTop100}/
                                        {newDataSourceForTheTable.length}
                                      </h2>
                                    </div>
                                    <div>
                                      <small className="summary-div-small-text-bottom-card summary-text">
                                        vs. {yesterdaysNumberOfKeywordsInTop100}{" "}
                                        yesterday
                                      </small>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </>
                          )}
                        <Row>
                          <Col
                            xs={24}
                            xl={24}
                            style={{ flexDirection: "column" }}
                          >
                            {firstTimeUser === true ? (
                              <Card
                                className="first-time-user-card ant-card"
                                title={
                                  <div className="card-title-body">
                                    <span className="card-title">
                                      Welcome! Start by setting up your account
                                    </span>
                                    <small>
                                      You need to set up your account first
                                    </small>
                                  </div>
                                }
                                extra={
                                  <div className="view-report-and-add-competitors-div"></div>
                                }
                                style={{
                                  width: "100%",
                                }}
                              >
                                <p>
                                  To start improving your SEO, you need to set
                                  up your account first.
                                </p>
                                <p>
                                  Once you have set up your account, you will be
                                  able to see your website's SEO performance
                                  right here.
                                </p>
                                <div>
                                  <span>
                                    <button
                                      style={{
                                        background: "#28A745",
                                        borderRadius: "4px",
                                        border: "none",
                                      }}
                                      onClick={takeMeToTheDashboardPage}
                                      data-cy="add-new-tracked-website"
                                      type="button"
                                      className="ant-btn ant-btn-primary first-time-user-button"
                                      ant-click-animating-without-extra-node="false"
                                    >
                                      <span>Take me to the dashboard page</span>
                                    </button>
                                  </span>
                                </div>
                              </Card>
                            ) : isCustomerPaying === true ? (
                              <>
                                <Alert
                                  message={`You are tracking ${newDataSourceForTheTable.length} out of maximum 100 tracked keywords for your website.`}
                                  type="info"
                                  style={{
                                    borderRadius: "4px",
                                    color: "#000",
                                    fontWeight: "400",
                                    marginBottom: "24px",
                                    padding: "2em",
                                  }}
                                ></Alert>

                                {/* <Card //THIS IS THE SUMMARY CARD
                          className="first-time-user-card"
                          title={
                            <div className="card-title-body">
                              <span className="card-title">Summary</span>
                            </div>
                          }
                          extra={<></>}
                          style={{
                            width: "100%",
                          }}
                        > */}

                                {/* </Card>  */}

                                <Card
                                  className="first-time-user-card"
                                  title={
                                    <div className="card-title-body">
                                      <span className="card-title">
                                        Keyword Overview
                                      </span>
                                      <small>{usersWebsite}</small>
                                    </div>
                                  }
                                  extra={
                                    <>
                                      <div className="view-report-and-add-competitors-div">
                                        <div
                                          className="card-link-div tracked-region-button"
                                          onClick={
                                            showTheChangeGoogleRegionsModalFunction
                                          }
                                        >
                                          Tracked region <CaretRightOutlined />
                                        </div>
                                        &nbsp;&nbsp;
                                        <div
                                          className="card-link-div add-keywords-button"
                                          onClick={showAddKeywordsModal}
                                        >
                                          Add keywords{" "}
                                          <PlusCircleOutlined
                                            style={{ marginLeft: "2px" }}
                                          />
                                        </div>
                                      </div>
                                      <small>
                                        Keywords are updated once every 24 hours
                                      </small>
                                    </>
                                  }
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  {Array.isArray(newDataSourceForTheTable) &&
                                  newDataSourceForTheTable.length ? (
                                    <Table
                                      scroll={{ x: 500 }}
                                      pagination={{ pageSize: 15 }}
                                      dataSource={newDataSourceForTheTable}
                                      columns={columns}
                                    />
                                  ) : (
                                    <div className="keywords-table">
                                      <Alert
                                        message="You haven't added any keywords to track yet."
                                        type="info"
                                        style={{
                                          borderRadius: "4px",
                                          color: "#000",
                                          fontWeight: "400",
                                        }}
                                      />
                                    </div>
                                  )}
                                </Card>
                              </>
                            ) : (
                              <>
                                <Alert
                                  message={`You are tracking ${newDataSourceForTheTable.length} out of maximum 3 tracked keywords for your website. If you need more keywords, please consider 
                           upgrading to another plan.`}
                                  type="info"
                                  style={{
                                    borderRadius: "4px",
                                    color: "#000",
                                    fontWeight: "400",
                                    marginBottom: "24px",
                                    padding: "2em",
                                  }}
                                ></Alert>
                                <Alert
                                  message={`Upgrade now to add more keywords`}
                                  type="success"
                                  onClick={navigateToPricesPageFunction}
                                  className="upgrade-now-button-on-the-keyword-tracker"
                                  style={{
                                    borderRadius: "4px",
                                    fontWeight: "700",
                                    textAlign: "center",
                                    marginBottom: "24px",
                                    padding: "2em",
                                    cursor: "pointer",
                                    backgroundColor: "#28A745",
                                    color: "white",
                                  }}
                                ></Alert>
                                <Card
                                  className="first-time-user-card"
                                  title={
                                    <div className="card-title-body">
                                      <span className="card-title">
                                        Keyword Overview
                                      </span>
                                      <small>{usersWebsite}</small>
                                    </div>
                                  }
                                  extra={
                                    <div className="view-report-and-add-competitors-div">
                                      <div
                                        className="card-link-div tracked-region-button"
                                        onClick={
                                          showTheChangeGoogleRegionsModalFunction
                                        }
                                      >
                                        Tracked region <CaretRightOutlined />
                                      </div>
                                      &nbsp;&nbsp;
                                      <div
                                        className="card-link-div add-keywords-button"
                                        onClick={showAddKeywordsModal}
                                      >
                                        Add keywords{" "}
                                        <PlusCircleOutlined
                                          style={{ marginLeft: "2px" }}
                                        />
                                      </div>
                                    </div>
                                  }
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  {Array.isArray(newDataSourceForTheTable) &&
                                  newDataSourceForTheTable.length ? (
                                    <Table
                                      scroll={{ x: 500 }}
                                      pagination={{ pageSize: 15 }}
                                      dataSource={newDataSourceForTheTable}
                                      columns={columns}
                                    />
                                  ) : (
                                    <div className="keywords-table">
                                      <Alert
                                        message="You haven't added any keywords to track yet."
                                        type="info"
                                        style={{
                                          borderRadius: "4px",
                                          color: "#000",
                                          fontWeight: "400",
                                        }}
                                      />
                                    </div>
                                  )}
                                </Card>
                              </>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </main>
                  </section>
                  {/* </div> */}
                  {/******** //BELOW IS THE MODAL FOR ADDING MORE KEYWORDS*********** */}
                  <Modal
                    title="Add keywords"
                    open={show}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form onSubmit={submitMoreKeywordsFunction}>
                      <div className="dashboard-modal-inner-box">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          {/* <Form.Label className="dashboard-modal-text-labels">
                    Add your keywords
                  </Form.Label> */}
                          <Typeahead
                            type="search"
                            spellcheck="false"
                            className="mb-5"
                            allowNew
                            /* onFocus={(e) => console.log(e.target.value)} */

                            autocapitalize="none"
                            autocomplete="off"
                            autocorrect="off"
                            id="custom-selections-example"
                            multiple
                            newSelectionPrefix="Add keyword: "
                            options={[]}
                            placeholder="Type a keyword..."
                            onInputChange={(e) => setInputChangeOnTheGo(e)} //  TESTING OUT SOME STUFF HERE. THIS ONE IS NOT NEEDED.
                            /* onBlur={(e) => setInputChangeOnTheGo(e)} */
                            /* selected={inputChangeOnTheGo} */
                            onChange={
                              (e) =>
                                pushEditedKeywordsToArrayFunction("keyword", e)

                              /* typeaheadRef.current.focus()) */
                            }
                            ref={typeaheadRef} // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
                          />
                          <Form.Text
                            className="please-note-text"
                            style={{
                              color: "black",
                              marginTop: "-1em",
                              maxWidth: "372px",
                            }}
                          >
                            Please note: You do not need to add a comma (',')
                            after each keyword.
                          </Form.Text>{" "}
                        </Form.Group>

                        {editedKeywords?.keyword &&
                        editedKeywords?.keyword?.length &&
                        loading === false ? (
                          <Button
                            style={{ marginBottom: "24px" }}
                            className="dashboard-modal-button"
                            variant="success"
                            type="submit"
                          >
                            <p className="dashboard-modal-button-text">
                              Add keywords
                            </p>
                          </Button>
                        ) : loading === true ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Loading />
                          </div>
                        ) : (
                          <Button
                            style={{ marginBottom: "24px" }}
                            className="dashboard-modal-button"
                            variant="success"
                            type="submit"
                            disabled="true"
                          >
                            <p className="dashboard-modal-button-text">
                              Add keywords
                            </p>
                          </Button>
                        )}
                      </div>
                    </Form>
                  </Modal>
                  {/* **************END OF MODAL*************** */}

                  {/******** //BELOW IS THE MODAL CHANGING GOOGLE REGION*********** */}
                  <Modal
                    title="Location and primary device"
                    open={showChangeGoogleRegionModal}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form
                      onSubmit={handleSubmitForChangingGoogleRegionAndDevice}
                    >
                      <div className="ant-card-body modal-input-field-and-text-underneath">
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          Your current target location and device:
                        </p>
                        <p>
                          Location:
                          <span style={{ fontWeight: "700" }}>{country}</span>
                        </p>
                        <p>
                          Device:{" "}
                          <span style={{ fontWeight: "700" }}>{device}</span>
                        </p>
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          You can change your input below:
                        </p>
                        <p>
                          Please enter the location of your primary target
                          audience.
                        </p>

                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Select
                            placeholder="Search..."
                            styles={customStylesWhenNotDisabled}
                            options={options}
                            value={selectedGoogleDomain}
                            onChange={onChangeForGoogleRegion}
                          />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "15px",
                            }}
                          >
                            Primary device
                          </p>
                          <p>
                            Please enter the primary device you would like to
                            track your keywords ranking via.
                          </p>

                          <Select
                            placeholder="Select..."
                            options={deviceOptions}
                            value={device?.device}
                            onChange={onChangeOfDeviceHandler}
                            styles={customStyles}
                          />
                        </Form.Group>
                        {errorInFetching === true && (
                          <div>
                            <small style={{ color: "red" }}>
                              Sorry, something went wrong. 🙁
                            </small>
                            <br></br>
                            <small style={{ color: "red" }}>
                              Please try again later.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="ant-card-body modal-input-field-and-text-underneath">
                        <form
                          onSubmit={
                            handleSubmitForChangingGoogleRegionAndDevice
                          }
                        >
                          {loading === true ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <Loading />
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {deviceChosen === true &&
                              googleRegionsChosen === true ? (
                                <Button
                                  style={{ marginBottom: "24px" }}
                                  className="dashboard-modal-button"
                                  variant="success"
                                  type="submit"
                                  onClick={
                                    handleSubmitForChangingGoogleRegionAndDevice
                                  }
                                >
                                  <p className="dashboard-modal-button-text">
                                    Change now
                                  </p>
                                </Button>
                              ) : (
                                <Button
                                  style={{ marginBottom: "24px" }}
                                  className="dashboard-modal-button"
                                  variant="secondary"
                                  type="submit"
                                  onClick={
                                    handleSubmitForChangingGoogleRegionAndDevice
                                  }
                                  disabled={true}
                                >
                                  <p className="dashboard-modal-button-text">
                                    Change now
                                  </p>
                                </Button>
                              )}
                            </div>
                          )}
                        </form>
                      </div>
                    </Form>
                  </Modal>
                  {/* **************END OF MODAL*************** */}

                  {/* //MODAL FOR THE DELETE BUTTON UNDERNEATH HERE:  */}

                  <Modal
                    title="Are you sure?"
                    open={showDeleteModal}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    /*  className="dashboard-edit-add-modal-outer-box"
                     */

                    className="modal-detete-button-outer-container"
                  >
                    <div
                      className="modal-delete-button-inner-container"
                      style={{ flexDirection: "row", padding: "24px" }}
                    >
                      <Button
                        style={{ width: "100%", marginRigth: "12px" }}
                        className="modal-delete-button-no-button"
                        variant="secondary"
                        onClick={handleCancel}
                      >
                        No
                      </Button>
                      <Button
                        style={{ width: "100%", marginLeft: "12px" }}
                        className="modal-delete-button-yes-button"
                        variant="success"
                        onClick={(event) => {
                          deleteARowInTableFunction(event);
                        }}
                      >
                        Yes
                      </Button>
                    </div>
                  </Modal>

                  {/* //BELOW IS THE MODAL FOR SHOWING THE TOP DOMAINS FOR A KEYWORD *************************** */}
                  <Modal
                    title={`Top domains for: ${keywordSelected}`}
                    open={showTop100Modal}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    /*  className="dashboard-edit-add-modal-outer-box"
                     */

                    className="modal-top-100-domains-outer-container"
                  >
                    <Table
                      scroll={{ x: 500 }}
                      pagination={{ pageSize: 15 }}
                      dataSource={
                        arrayOfKeywordsWithAllInformation[keyForTheTop100List]
                          ?.top100PositionAndLink
                      }
                      columns={columnsForTheTop100Table}
                    />
                  </Modal>

                  {/* //BELOW IS THE MODAL FOR SHOWING THE TREND FOR A KEYWORD *************************** */}
                  <Modal
                    title={`Trend for: ${keywordSelected}`}
                    open={showTrendModal}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    /*  className="dashboard-edit-add-modal-outer-box"
                     */

                    className="modal-top-100-domains-outer-container"
                  >
                    <div
                      className="outer-div-for-the-overall-seo-score-chart"
                      style={{ width: "auto", height: "500px" }}
                    >
                      <div
                        style={{ width: "100%", height: "100%" }}
                        className="inner-div-for-the-overall-seo-score-chart"
                      >
                        <ResponsiveContainer width="95%" height="95%">
                          <LineChart
                            width="100%"
                            height="100%"
                            data={
                              arrayOfKeywordsWithAllInformation[
                                keyForTheTrendsList
                              ]?.historicRankingsForThisKeyword
                            }
                            margin={{
                              top: 20,
                              right: 0,
                              left: -20,
                              bottom: 5,
                            }}
                            style={{
                              paddingLeft: "0",
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="timestampForThisPosition" />
                            <YAxis type="number" domain={[0, 100]} />
                            <Tooltip />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="rankingPosition"
                              stroke="#8884d8"
                            />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Modal>

                  {/* //BELOW IS THE MODAL THAT SHOWS UP IF A NON-PAYING USER IS TRYING TO ADD MORE THAN 3 KEYWORDS  *************************** */}

                  <Modal
                    title={`Please consider upgrading`}
                    open={numberOfKeywordsExceeded}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form onSubmit={navigateToPricesPageFunction}>
                      <div className="dashboard-modal-inner-box">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          <Form.Text
                            className="please-note-text"
                            style={{
                              color: "black",
                              marginTop: "-1em",
                              maxWidth: "372px",
                            }}
                          >
                            You can only track{" "}
                            <span style={{ fontWeight: "900" }}>3</span>{" "}
                            keywords on the free plan. Please consider upgrading
                            to track more keywords.
                          </Form.Text>{" "}
                        </Form.Group>

                        <Button
                          style={{ marginBottom: "24px" }}
                          className="dashboard-modal-button"
                          variant="success"
                          type="submit"
                        >
                          <p className="dashboard-modal-button-text">
                            Upgrade now
                          </p>
                        </Button>
                      </div>
                    </Form>
                  </Modal>

                  {/* //BELOW IS THE MODAL THAT SHOWS UP IF A PAYING-USER IS TRYING TO ADD MORE THAN 100 KEYWORDS  *************************** */}

                  <Modal
                    title={`You have reached the limit`}
                    open={numberOfKeywordsExceededForPayingUser}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form /* onSubmit={navigateToPricesPageFunction} */>
                      <div className="dashboard-modal-inner-box">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          <Form.Text
                            className="please-note-text"
                            style={{
                              color: "black",
                              marginTop: "-1em",
                              maxWidth: "372px",
                            }}
                          >
                            You can only track{" "}
                            <span style={{ fontWeight: "900" }}>100</span>{" "}
                            keywords on the paid plan. If you would like to
                            track more keywords then please write us on
                            contact@serpmaze.com
                          </Form.Text>{" "}
                        </Form.Group>
                      </div>
                    </Form>
                  </Modal>
                </Content>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
